exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notification-desc[data-v-ec7112ca]{font-size:13px}.upload[data-v-ec7112ca]{position:relative}.upload button[data-v-ec7112ca]{position:relative;z-index:1}.upload form input[type][data-v-ec7112ca]{opacity:0;width:100%;height:100%;position:absolute;top:0;z-index:2;left:0;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-ec7112ca","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/pages/automation/modals/importNotificationsModal.vue
// module id = 1132
// module chunks = 0